<template>
  <a :href="`/blogs/${article.handle}`" class="gsl" :aria-label="`Read more about ${article.title}`">
    <ImageField
      class="gsl__image"
      :obj="{ url: article.image, alt: article.title, width: 832, height: 630 }"
      width-param="width"
      sizes="1000px"
      :load="true"
    />
    <div class="gsl__info">
      <div class="gsl__tag-time">
        <span v-if="tag" class="gsl__tag" :aria-label="`Tag: ${tag}`">{{ tag }}</span>
        <span v-if="tag && timeToRead" class="gsl__seperator" aria-hidden="true"></span>
        <span v-if="timeToRead" class="gsl__time" :aria-label="`Estimated reading time: ${timeToRead} minutes`">{{ timeToRead }} min Read</span>
      </div>
      <h2 class="gsl__title">{{ article.title }}</h2>
      <p class="gsl__desc" v-html="article.description"></p>
    </div>
  </a>
</template>

<script setup>
  import { computed, toRefs } from 'vue';
  import ImageField from '../../global/image.vue';

  const props = defineProps({
    article: {
      type: Object,
      required: true,
    },
  });

  const { article } = toRefs(props);

  const tag = computed(() => {
    const catTag = article.value.tags.filter((tag) => tag.includes('category:'));
    if (catTag.length) {
      return catTag[0].split(':')[1];
    }
  });

  const timeToRead = computed(() => {
    const timeTag = article.value.tags.filter((tag) => tag.includes('time:'));
    if (timeTag.length) {
      return timeTag[0].split(':')[1];
    }
  });
</script>
